import React from "react";
import Modal from 'react-bootstrap/Modal';
import { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Info.scss"
import { List, ListItem, ListItemIcon} from "@material-ui/core";
import { ListItemButton } from "@mui/material";
import SendIcon from '@mui/icons-material/Send';

export const When = () => {

    const [show, setShow] = useState(true);
    let history = useHistory();


    const handleClose = () => {
        setShow(false);
        history.push({
            pathname: `/score`,
        });
    };

    return (

        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton style={{ border: "0px" }}>
            </Modal.Header>
            <Modal.Body>
                <div className="container grade-what">
                    <p className="px-xl-4 px-2 text-justify">
                    <strong>Utiliza eGrade cuando necesites conocer mejor a un nuevo socio comercial de forma rápida y fiable.</strong>
                    </p>
                    <p className="px-xl-4 px-2 text-justify">eGrade es especialmente útil para:</p>
                    <List className="list">
                        <ListItem disablePadding>
                            <div className="row ps-xl-2">
                                <div className="col-1">
                                    <ListItemButton>
                                        <ListItemIcon className="arrow-icon" style={{color:'#f4bb64'}}>
                                          <SendIcon/>
                                        </ListItemIcon>
                                    </ListItemButton>
                                </div>
                                <div className="col-11 prospect-text pt-2">
                                    <p className="prospect"><strong>Prospectar</strong> mercados y clientes.</p>
                                </div>
                            </div>
                        </ListItem>
                        <ListItem disablePadding>
                            <div className="row ps-xl-2">
                                <div className="col-1">
                                    <ListItemButton>
                                        <ListItemIcon className="arrow-icon" style={{color:'#f4bb64'}}>
                                          <SendIcon/>
                                        </ListItemIcon>
                                    </ListItemButton>
                                </div>
                                <div className="col-11 ps-4 pt-2">
                                    <p className="optimize"><strong>Optimizar</strong> la selección y calificación de tus proveedores.</p>
                                </div>
                            </div>
                        </ListItem>
                        <ListItem disablePadding>
                            <div className="row ps-xl-2">
                                <div className="col-1">
                                    <ListItemButton>
                                        <ListItemIcon className="arrow-icon" style={{color:'#f4bb64'}}>
                                        <SendIcon/>
                                        </ListItemIcon>
                                    </ListItemButton>
                                </div>
                                <div className="col-11 ps-3 pt-2">
                                    <p className="plan"><strong>Planificar</strong> tus ventas, optimizando tus decisiones, con información fiable.</p>
                                </div>
                            </div>
                        </ListItem>
                    </List>
                </div>
               
            </Modal.Body>
         
        </Modal>

    )
}